import { render, staticRenderFns } from "./InstrumentCertificado.vue?vue&type=template&id=78ce8d0f&scoped=true&"
import script from "./InstrumentCertificado.vue?vue&type=script&lang=js&"
export * from "./InstrumentCertificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ce8d0f",
  null
  
)

export default component.exports